/**
 * Decodes HTML entities in a string
 * Converts entities like &#x27; to ' and &lt; to <
 */
export function decodeHtmlEntities(text: string | null | undefined): string {
  if (!text) return '';

  const textarea = document.createElement('textarea');
  textarea.innerHTML = text;
  return textarea.value;
}
